import { render, staticRenderFns } from "./denegados.vue?vue&type=template&id=4d654cc0"
import script from "./denegados.vue?vue&type=script&lang=js"
export * from "./denegados.vue?vue&type=script&lang=js"
import style0 from "./denegados.vue?vue&type=style&index=0&id=4d654cc0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports